if (!customElements.get('shop-by-size')) {
  class ShopBySize extends HTMLElement {
    constructor() {
      super();
      this.syncActiveState = this.syncActiveState.bind(this);
      this.handlePopState = this.handlePopState.bind(this);
      this.boundClickHandlers = new Map();
    }

    connectedCallback() {
      this.buttons = [...this.querySelectorAll('.shop-by-size__button')];

      this.buttons.forEach((button) => {
        const handler = (event) => this.handleButtonClick(event, button);
        this.boundClickHandlers.set(button, handler);
        button.addEventListener('click', handler);
      });

      this.syncActiveState();

      window.addEventListener('popstate', this.handlePopState);

      const productGridContainer = document.getElementById('ProductGridContainer');
      if (productGridContainer) {
        this.gridObserver = new MutationObserver(this.syncActiveState);
        this.gridObserver.observe(productGridContainer, { childList: true, subtree: false });
      }
    }

    disconnectedCallback() {
      this.buttons?.forEach((button) => {
        const handler = this.boundClickHandlers.get(button);
        if (handler) button.removeEventListener('click', handler);
      });
      this.boundClickHandlers.clear();

      window.removeEventListener('popstate', this.handlePopState);
      this.gridObserver?.disconnect();
    }

    handlePopState() {
      this.syncActiveState();
    }

    handleButtonClick(event, button) {
      if (typeof FacetFiltersForm === 'undefined') return;

      event.preventDefault();

      const params = new URLSearchParams(window.location.search);
      const size = button.dataset.sizeValue ?? '';
      const availability = button.dataset.availability === 'true';

      if (size === '') {
        params.delete('filter.v.option.talla');
        if (!availability) params.delete('filter.v.availability');
      } else {
        const current = params.getAll('filter.v.option.talla');
        params.delete('filter.v.option.talla');

        if (current.includes(size)) {
          current.filter((v) => v !== size).forEach((v) => params.append('filter.v.option.talla', v));
        } else {
          current.forEach((v) => params.append('filter.v.option.talla', v));
          params.append('filter.v.option.talla', size);
        }

        if (availability) {
          params.set('filter.v.availability', '1');
        }

        const remaining = params.getAll('filter.v.option.talla');
        if (remaining.length === 0 && !availability) {
          params.delete('filter.v.availability');
        }
      }

      FacetFiltersForm.renderPage(params.toString());
    }

    syncActiveState() {
      const active = new URLSearchParams(window.location.search).getAll('filter.v.option.talla');

      this.buttons?.forEach((button) => {
        const sizeValue = button.dataset.sizeValue ?? '';
        const isActive = sizeValue === '' ? active.length === 0 : active.includes(sizeValue);

        button.classList.toggle('is-active', isActive);

        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('shop-by-size', ShopBySize);
}
